import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { SOLD_SERVICES_CONTENT_MODE } from '../typings'
import type { ServicesAddedNewProps } from './ServicesAddedNew'
import { locationToLocationDTO } from '@user/store/entityLocations'
import { selectAllServiceFrequencies } from '@user/store/serviceFrequency'
import { selectAllLeadOppProducts } from '@user/store/leadOppProducts'

type Props = Pick<ServicesAddedNewProps, 'type' | 'serviceLocations'>

export function useDataNew(props: Props) {
  const { type, serviceLocations } = props

  const services = useSelector(selectAllLeadOppProducts)
  const serviceFrequencies = useSelector(selectAllServiceFrequencies)

  const localMode =
    type === SOLD_SERVICES_CONTENT_MODE.NewOpp ||
    type === SOLD_SERVICES_CONTENT_MODE.DuplicateOpp

  const locations = useMemo(() => {
    switch (type) {
      case SOLD_SERVICES_CONTENT_MODE.ConvertLead:
      case SOLD_SERVICES_CONTENT_MODE.DuplicateOpp:
      case SOLD_SERVICES_CONTENT_MODE.CloneOpp:
        return serviceLocations
      case SOLD_SERVICES_CONTENT_MODE.NewOpp:
        return serviceLocations.map((s) => locationToLocationDTO(s))
    }
  }, [serviceLocations, type])

  const svcCount = services.length
  const title = `Services Added (${svcCount})`

  return {
    title,
    localMode,
    locations,
    serviceFrequencies,
  }
}
